export const AllowedScopes = {
    BANKFEEDS: 'bankfeeds',
}
